// **  Initial State
const initialState = {
	officeData: {},
	officeProfileInfo: {has_draft: false, lock_edit: false, can_cancel: false, can_send: false, status: '', status_code: '',  reason: '', active: true},
	loading: false
}

export const officeReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'OFFICE_SET_REGISTER_INFO':
			return {
				...state,
				officeData: action.data
			}
		case 'OFFICE_SET_OFFICE_PROFILE_INFO':
			return {
				...state,
				officeProfileInfo: action.data
			}
		case 'OFFICE_INFO_LOADING_START':
			return {
				...state, loading: true
			}
		case 'OFFICE_INFO_LOADING_END':
			return {
				...state, loading: false
			}
		default:
			return state
	}
}
